module.exports = __webpack_public_path__ + "static/img/20020 (4).1e97e8f.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20020 (4).webp
// module id = QsoT
// module chunks = 14